export const viewHeaderCopy = {
  header: 'Email Header',
};
